import { useLinkRelValue } from "hooks";
import { ChakraLink } from "@airhelp/react-ui-components";
import type { LinkProps } from "./Link.d";

const Link = ({ text, href, isExternal = false }: LinkProps) => {
  const relValue = useLinkRelValue(href);

  return (
    <ChakraLink rel={relValue} href={href} isExternal={isExternal} fontSize="md" _visited={{}}>
      {text}
    </ChakraLink>
  );
};

export default Link;
